<template>
  <div class="app-container">
    <!-- 旧两个页签（类型考试/课程考试）的筛选条。课后考试有自己的一套，见 afterClass.vue -->
    <el-card v-if="activeName !== '3'" class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="题目分类：">
            <el-select v-model="query.topicClassificationId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in topicClassOptions" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户姓名：">
            <el-input v-model="query.realName" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户手机号：">
            <el-input v-model="query.userPho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <!-- <el-form-item label="用户身份：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="类型考试" name="1"></el-tab-pane>
          <el-tab-pane label="课程考试" name="2"></el-tab-pane>
          <!-- REQ-2026-403009：课后考试是另一套数据（course_exam_paper）、列也不同，
               所以单独页签 + 单独组件，**现有列表与查询零改动** -->
          <el-tab-pane label="课后考试" name="3"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName !== '3'" class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" icon="el-icon-plus">导出</el-button>
        </div>
      </div>
      <after-class-tab v-if="activeName === '3'" />
      <el-table v-if="activeName !== '3'" v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="用户信息" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.realName}}{{row.identity?'('+row.identity+')':''}}<br />{{row.userPho}}
          </template>
        </el-table-column>
        <el-table-column label="课程" prop="courseName" align="center" v-if="activeName === '2'" :key="Math.random()" />
        <el-table-column label="试卷分类" prop="name" align="center" />
        <el-table-column label="考试分数" prop="examScores" align="center" />
        <el-table-column label="错题数量" prop="wrongNum" align="center" v-if="activeName === '1'" :key="Math.random()" />
        <el-table-column label="考试时间" prop="createdTime" sortable="custom" align="center" />
      </el-table>
      <pagination v-show="total>0 && activeName !== '3'" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import courseExamRecordsApi from '@/api/course/courseExamRecords'
import Pagination from '@/components/Pagination'
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'
import afterClassTab from './afterClass.vue'
export default {
  components: {
    Pagination,
    afterClassTab
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      activeName: '1',
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    courseTopicClassificationApi.fetchOptions().then(({ data }) => this.topicClassOptions = data)
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    handleClick() {
      // 课后考试页签由子组件自己取数：旧表没有 exam_type=3 的数据，
      // 在这里白跑一次还会把 list 清空造成闪动
      if (this.activeName === '3') {
        return
      }
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.examType = +this.activeName
      this.listLoading = true
      return courseExamRecordsApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 2)
      }
    },
    changeSwitch(row) {
      sysGoodsCategorizeApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      questionsApi.getImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.gradeAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.gradeAdd.handleUpdate(row)
    },
    handleDownload() {
      this.$router.push("/export/list?code=ExportExamRecords")
    },
  }
}
</script>
